/* eslint-disable react/prop-types */
import { createPortal } from 'react-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { Cross } from '../../../assets/svgs/icons'
import styles from './styles.module.css'

export const UpsellBaseModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  headerIcon,
  children,
  primaryAction,
  secondaryAction,
  tertiaryAction,
  showCloseButton = true,
  className = '',
  contentClassName = '',
  headerClassName = '',
  subtitleClassName = '',
  footerClassName = '',
  titleClassName = '',
  titleId,
}) => {
  if (typeof document === 'undefined' || !document.body) {
    return null
  }

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className={`${styles.modal} ${className}`}
            initial={{ opacity: 0, scale: 0.94, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.94, y: 16 }}
            transition={{ duration: 0.18 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby={titleId}
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles.body}>
              {showCloseButton && onClose && (
                <button
                  type="button"
                  className={styles.closeButton}
                  onClick={onClose}
                  aria-label="Fechar"
                >
                  <Cross color="#7c7c84" width={11} height={12} />
                </button>
              )}

              <header className={`${styles.header} ${headerClassName}`}>
                {headerIcon && (
                  <div className={styles.headerIcon}>{headerIcon}</div>
                )}
                {title && (
                  <h2 id={titleId} className={`${styles.title} ${titleClassName}`}>
                    {title}
                  </h2>
                )}
                {subtitle && (
                  <p className={`${styles.subtitle} ${subtitleClassName}`}>{subtitle}</p>
                )}
              </header>

              {children && (
                <div className={`${styles.content} ${contentClassName}`}>
                  {children}
                </div>
              )}

              {(primaryAction || secondaryAction || tertiaryAction) && (
                <footer className={`${styles.footer} ${footerClassName}`}>
                  {primaryAction && (
                    <button
                      type="button"
                      className={`${styles.primaryButton}${primaryAction.loading ? ` ${styles.primaryButtonLoading}` : ''}`}
                      onClick={primaryAction.onClick}
                      disabled={primaryAction.disabled || primaryAction.loading}
                    >
                      {primaryAction.loading && (
                        <span className={styles.primaryButtonSpinner} aria-hidden="true" />
                      )}
                      <span>
                        {primaryAction.loading && primaryAction.loadingLabel
                          ? primaryAction.loadingLabel
                          : primaryAction.label}
                      </span>
                    </button>
                  )}
                  {(tertiaryAction || secondaryAction) && (
                    <div className={styles.footerLinks}>
                      {tertiaryAction && (
                        <button
                          type="button"
                          className={styles.tertiaryLink}
                          onClick={tertiaryAction.onClick}
                        >
                          {tertiaryAction.label}
                        </button>
                      )}
                      {secondaryAction && (
                        <button
                          type="button"
                          className={styles.secondaryLink}
                          onClick={secondaryAction.onClick}
                          disabled={secondaryAction.disabled}
                        >
                          {secondaryAction.label}
                        </button>
                      )}
                    </div>
                  )}
                </footer>
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  )
}

export default UpsellBaseModal
